'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _vstui = require('@vitalsource/vstui');

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var CheckboxChecked = function (_PureComponent) {
  function CheckboxChecked() {
    return _classCallCheck(this, CheckboxChecked), _possibleConstructorReturn(this, (CheckboxChecked.__proto__ || Object.getPrototypeOf(CheckboxChecked)).apply(this, arguments));
  }

  return _inherits(CheckboxChecked, _PureComponent), _createClass(CheckboxChecked, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_vstui.Icon, _extends({}, this.props, {
        height: 14,
        width: 14
      }), _react2.default.createElement('rect', {
        fill: '#ffffff',
        height: '14',
        rx: '3',
        width: '14'
      }), _react2.default.createElement('path', {
        className: 'primary',
        d: 'M10.793 5.563L6.648 9.707c-.39.39-1.024.39-1.415 0l-1.94-1.94A1 1 0 1 1 4.707 6.35L5.94 7.585 9.379 4.15a.999.999 0 1 1 1.414 1.413M11 0H3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V3a2.999 2.999 0 0 0-3-3'
      }), _react2.default.createElement('path', {
        className: 'secondary',
        d: 'M1 3.003v7.994C1 12.104 1.896 13 3.003 13h7.994A2.002 2.002 0 0 0 13 10.997V3.003A2.002 2.002 0 0 0 10.997 1H3.003A2.002 2.002 0 0 0 1 3.003zm-1 0A3.002 3.002 0 0 1 3.003 0h7.994A3.002 3.002 0 0 1 14 3.003v7.994A3.002 3.002 0 0 1 10.997 14H3.003A3.002 3.002 0 0 1 0 10.997V3.003z'
      }));
    }
  }]), CheckboxChecked;
}(_react.PureComponent);

CheckboxChecked.displayName = 'CheckboxChecked', CheckboxChecked.vstuiName = 'Icon', exports.default = CheckboxChecked;